module.exports = function() {
  return new Worker(__webpack_public_path__ + "ee33ecb831bfebb4a786.worker.js");
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/worker-loader/dist/cjs.js!./node_modules/vue-pdf/node_modules/pdfjs-dist/es5/build/pdf.worker.js
// module id = Mpk9
// module chunks = 0